export const Diagnostic = {
  V1: {
    DatabaseGroupJoined: 'GSC.Client.Diagnostic.V1.DatabaseGroupJoined',
    TenantGroupJoined: 'GSC.Client.Diagnostic.V1.TenantGroupJoined'
  }
} as const

export type DiagnosticEventDatabaseGroupJoinedSignalREvent = {
  databaseInstanceId: string
  groupName: string
  text: string
}

export type DiagnosticEventTenantGroupJoinedSignalREvent = {
  tenantId: string
  groupName: string
  text: string
}
